import React from 'react';

import Intro from '../Slider/Intro';
import Slide from '../Slider/Theme/Slide';

import './style.scss';
import Outro from '../Slider/Outro';

const StackIntro = ({ title, body, backgroundImage, backgroundImageMobile, index, setActiveIndex, previous = false, active = false, forward = false }) => {
  return (
    <div className={`StackItem ${index} ${previous ? 'previous' : ''} ${active ? 'active' : ''} ${forward ? 'forward' : 'backward'}`}>
      <div className="StackItem__content">
        <Intro
          title={title}
          body={body}
          backgroundImage={backgroundImage}
          backgroundImageMobile={backgroundImageMobile}
          onStart={() => setActiveIndex(index + 1)}
        />
      </div>
    </div>
  );
};

const StackOutro = ({ title, body, backgroundImage, index, setActiveIndex, previous = false, active = false, forward = false }) => {
  return (
    <div className={`StackItem ${index} ${previous ? 'previous' : ''} ${active ? 'active' : ''} ${forward ? 'forward' : 'backward'}`}>
      <div className="StackItem__content">
        <Outro
          title={title}
          body={body}
        />
      </div>
    </div>
  );
};

const StackItem = ({ title, body, images, externalUrl, externalUrlTitle, itemIndex, index, setActiveIndex, previous = false, active = false, forward = false, buttonText }) => {
  return (
    <div className={`StackItem ${index} ${previous ? 'previous' : ''} ${active ? 'active' : ''} ${forward ? 'forward' : 'backward'}`}>
      <div className="StackItem__content">
        <Slide
          index={itemIndex}
          title={title}
          body={body}
          images={images}
          externalUrl={externalUrl}
          externalUrlTitle={externalUrlTitle}
          buttonText={buttonText}
          onNext={() => setActiveIndex(index + 1)}
        />
      </div>
    </div>
  );
};

const Stack = ({ introTitle, introBody, introBackgroundImage, introBackgroundImageMobile, outroTitle, outroBody, activeIndex, previousIndex, onGoto, pages }) => {
  const onItemClick = (newIndex) => {
    onGoto(newIndex);
  };

  const renderThemeItems = (items, themeIndex, counter) => {
    const themeItems = [];
    let c = counter;
    items.forEach((item, itemIndex) => {
      const index = c;
      themeItems.push((
        <StackItem
          key={index}
          itemIndex={itemIndex}
          index={index}
          title={item.getIn(['entity', 'field_title', 0, 'value'])}
          body={item.getIn(['entity', 'field_body', 0, 'value'])}
          images={item.getIn(['entity', 'field_jaaroverzicht_images'])}
          buttonText={item.getIn(['entity', 'field_label', 0, 'value'], '')}
          active={index === activeIndex}
          previous={index !== activeIndex && index === previousIndex}
          forward={activeIndex > previousIndex}
          setActiveIndex={onItemClick}
        />
      ));
      c += 1;
    });
    return themeItems;
  };

  const renderThemes = () => {
    let themes = [];
    let counter = 0;
    // Intro slide.
    themes.push((
      <StackIntro
        key={0}
        index={0}
        title={introTitle}
        body={introBody}
        backgroundImage={introBackgroundImage}
        backgroundImageMobile={introBackgroundImageMobile}
        active={activeIndex === 0}
        previous={activeIndex !== 0 && previousIndex === 0}
        forward={activeIndex > previousIndex}
        setActiveIndex={onItemClick}
      />
    ));

    counter += 1;

    // Render slides.
    const slideItems = renderThemeItems(pages, 0, counter);
    themes = themes.concat(slideItems);

    counter += slideItems.length;

    // Outro slide.
    themes.push((
      <StackOutro
        key={counter}
        index={counter}
        title={outroTitle}
        body={outroBody}
        active={counter === activeIndex}
        previous={counter !== activeIndex && counter === previousIndex}
        forward={activeIndex > previousIndex}
      />
    ));
    return themes;
  };

  return (
    <div className="Stack">
      {renderThemes()}
    </div>
  );
};

export default Stack;
